<template>

<div class="main list-view">

	<div class="sub-header">
		<div class="input-with-control">
			<input type="search" ref="search_term" v-model="filters.search_term" placeholder="Search..." @search="getList('main')" v-focus>
			<div class="button action input-go" @click="getList('main')"><i class="fas fa-search"></i></div>
		</div>
		<div class="controls">
			<pagination :paging="paging" @updatePage="goToPage"></pagination>
		</div>
	</div>

	<div class="filters">
		<ul class="checkbox-group">
			<li>
				<span :class="['pointer', 'far', filters.hidden ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('hidden')"></span>
				<label>Hidden</label>
			</li>
			<li>
				<span :class="['pointer', 'far', filters.inactive ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('inactive')"></span>
				<label>Inactive</label>
			</li>
			<li v-if="!getAdministratorFlag">
				<span :class="['pointer', 'far', filters.client ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('client')"></span>
				<label>Custom</label>
			</li>
		</ul>
		<div class="divider"></div>
		<div>
			<div class="button neutral" @click="clearFilters(1)">Clear Filters</div>
			<div class="button action" @click="addItem()">Add Manufacturer</div>
			<div :class="['button', gettingExport ? 'disabled' : 'neutral']" @click="doExport()">Export CSV</div>
			<div class="message">{{ exportMessage }}</div>
		</div>
	</div>

	<div class="list">
	    <div v-if="list.length == 0" class="empty-list">
	        This list is empty
	    </div>
	    <table v-else class="data-list" cellpadding="0" cellspacing="0">
			<thead>
				<tr>
					<th class="list left">Description</th>
					<th class="list center">Hidden</th>
					<th class="list center">Inactive</th>
					<th v-if="!getAdministratorFlag" class="list center">Custom</th>
					<th class="list right"></th>
				</tr>
			</thead>
			<tr v-for="(item, index) in list" class="clickable-list-item">
				<td class="list left" @click="getItem(item)">{{ item.description }}</td>
				<td class="list center" @click="getItem(item)"><i v-if="item.hidden" class="fas fa-check"></i></td>
				<td class="list center" @click="getItem(item)"><i v-if="item.inactive == 1" class="fas fa-check"></i></td>
				<td v-if="!getAdministratorFlag" class="list center" @click="getItem(item)"><i v-if="item.client_id == client_id" class="fas fa-check"></i></td>
				<td class="right"><i v-if="!filters.client" class="fa fa-calendar-check" @click="showMapHoliday(item)" /></td>
			</tr>
		</table>

	</div>

	<iframe id="download" src="" style="display: none;"></iframe>

	<div v-if="showModal" class="modal">
		<div class="inner">
			<h2>{{ listDetail.manufacturer_id != 'new' ? 'Edit' : 'Add' }} A Manufacturer</h2>
			<div class="content">
				<label>Description</label>
				<input type="text" v-model="listDetail.description" :disabled="!userCanEdit"/>

				<label>Link</label>
				<input type="text" v-model="listDetail.link_name" :disabled="!userCanEdit"/>

				<div style="margin: 0.5em 0 0 0;">
					<label class="checkbox" style="margin: 0 1em 0 0;">
						<input type="checkbox" v-model="listDetail.hidden" value="1">
						<span><i class="fas fa-check-circle"></i>Hide Manufacturer</span>
					</label>
					<label class="checkbox" style="margin: 0 1em 0 0;">
						<input type="checkbox" v-model="listDetail.inactive" value="1" :disabled="!userCanEdit">
						<span :class="{ disabled: !userCanEdit }"><i class="fas fa-check-circle"></i>{{ listDetail.inactive == '1' ? 'Re' : 'De'}}activate Manufacturer</span>
					</label>
					<label class="checkbox">
						<input type="checkbox" v-model="listDetail.dropship_eligible" value="1" :disabled="!userCanEdit">
						<span :class="{ disabled: !userCanEdit }"><i class="fas fa-check-circle"></i>Dropship Eligible</span>
					</label>
				</div>

				<div v-if="userCanEdit && listDetail.manufacturer_id != 'new'">
					<label>Merge Into</label>
					<div class="input-with-control">
						<input type="search" ref="merge_search_term" v-model="filters.merge_search_term" placeholder="Search..." @search="getList('merge')" v-focus>
						<div class="button action input-go" @click="getList('merge')"><i class="fas fa-search"></i></div>
					</div>
					<ul v-if="mergeList.length > 0" class="modal-search-result clickable-list">
						<li v-for="(manufacturer, index) in mergeList" class="clickable-list-item" @click="setMerge(manufacturer)">{{ manufacturer.description }}</li>
					</ul>
				</div>

				<div class="message-overlay" v-if="modalMessage">
					<p>{{ modalMessage }}</p>
					<p v-if="modalSuccess"><i class="fa fa-check" /></p>
				</div>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="backToList()">Cancel</div>
				<div :class="['button', 'spaced', !canSave || saving ? 'disabled' : 'action']" @click="saveItem()">Save Manufacturer</div>
			</div>
		</div>
	</div>

	<map-policy-detail v-if="showMapHolidayFor" :manufacturerId="showMapHolidayFor" @backToList="(showMapHolidayFor = false)" :key="'manufacturer_id_' + listDetail.manufacturer_id" />

	<help-popup :helpLink="{162:'Manufacturers'}" :tours="false"></help-popup>


</div>

</template>

<script>
import MapPolicyDetail from '@/components/MapPolicyDetail.vue'
import HelpPopup from '@/components/HelpPopup.vue'

export default {
	name: 'manufacturers',
    components: {
		'map-policy-detail': MapPolicyDetail,
		'help-popup': HelpPopup
    },
	data() {
		return {
			client_id: '',
            loading: true,
			filters: {},
			list: [],
			mergeList: [],
			paging: {},
			showModal: false,
			gettingExport: false,
			listDetail: {},
			exportMessage: '',
			exporting: false,
			saving: false,
			modalMessage: '',
			modalSuccess: false,
			showMapHolidayFor: false
		}
	},
	created() {
		this.clearFilters(true)
	},
	computed: {
		canSave() {
			return this.listDetail.description
		},
		userCanEdit() {
			return this.listDetail.client_id == this.client_id || this.getAdministratorFlag
		}
	},
	methods: {
		clearFilters(getList) {
			this.filters = {
				page: 1,
				search_term: '',
				merge_search_term: '',
				current_id: '',
				internal_usehidden_only: 0,
				inactive: 0,
				do_export: 0
			}
			if (getList) {
				this.getList('main')
			}
		},
		getList(context) {
			this.loading = true
			this.apiCall({ destination: 'get_list_manufacturers', data: this.filters }).then(obj => {
				this.client_id = obj.client_id
				this.loading = false
				this.filters.page = 1
				if (this.filters.do_export) {
					this.filters.do_export = 0
					var outputFile = obj.file_name
					// accommodate live server filecache latency
					setTimeout(() => {
						document.getElementById("download").src = "//" + document.location.hostname + "/download.php?file_name=" + obj.file_name + "&output_file_name=" + outputFile
						this.exporting = false
						this.exportMessage = ''
					}, 1500)
				} else {
					if (context == 'merge') {
						this.mergeList = obj.manufacturers
					} else {
						this.list = obj.manufacturers
						if (obj.paging) {
							this.paging = obj.paging
						}
					}
				}
			}).catch(err => {
				console.log(err)
			})
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		toggleFilter(which) {
			this.filters[which] = !this.filters[which]
			this.getList()
		},
		showMapHoliday(item) {
			this.showMapHolidayFor = item.manufacturer_id
		},
		getItem(item) {
			if (this.loading) { return }
			this.mergeList = []
			this.filters.merge_search_term = ''
			this.loading = true
			this.showModal = true
			this.apiCall({ destination: 'get_item_manufacturer', data: { manufacturer_id: item.manufacturer_id } }).then(obj => {
				this.loading = false
				if (obj.status == 'success') {
					this.listDetail = obj.manufacturer
					this.filters.current_id = this.listDetail.manufacturer_id
				} else {
					this.modalMessage = obj.message
				}
			})
		},
		setMerge(manufacturer) {
			this.listDetail.merge_into = manufacturer.manufacturer_id
			this.filters.merge_search_term = manufacturer.description
			this.mergeList = []
		},
		addItem() {
			this.listDetail = {
				manufacturer_id: 'new',
				client_id: this.client_id,
				description: '',
				internal_use_only: 0,
				inactive: 0
			}
			this.userCanEdit = true
			this.showModal = true
		},
		saveItem() {
			if (this.saving) { return }
			this.saving = true
			this.modalSuccess = false
			this.modalMessage = 'Saving manufacturer...'
			this.apiCall({ destination: 'save_item_manufacturer', data: this.listDetail }).then(obj => {
				if (obj.status == 'success') {
					if (this.listDetail.merge_into) {
						this.modalMessage = 'Manufacturer merged! (' + obj.merge_count + ' products affected)'
					} else {
						this.modalMessage = 'Manufacturer saved!'
					}
					this.modalSuccess = true
					setTimeout(() => {
						this.backToList()
						this.getList()
						this.modalMessage = ''
						this.saving = false
					}, 2000);
				} else {
					this.modalMessage = obj.message
					setTimeout(() => { 
						this.modalMessage = ''
						this.saving = false
					}, 2000);
				}
			}).catch(err => {
				console.log(err)
			})
		},
		backToList() {
			this.showModal = false
			this.filters.merge_search_term = ''
			this.current_id = ''
			this.listDetail = {}
		},
		doExport() {
			if (this.exporting) { return }
			this.exporting = true
			this.exportMessage = 'Generating CSV for ' + this.list.length + ' items...'
			this.filters.do_export = true
			this.getList()
		}
	}
}
</script>

<style lang="scss" scoped>
.modal .inner {
  max-height: 50em;
  max-width: 50em;
}
</style>
